module.exports = __webpack_public_path__ + "static/media/list-view.f257aad4.svg";